import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NodeClass;
function Node() {
  if (NodeClass === VOID) {
    class $ {
      constructor(item, next) {
        this.b61_1 = item;
        this.c61_1 = next;
      }
    }
    initMetadataForClass($, 'Node');
    NodeClass = $;
  }
  return NodeClass;
}
var engines$iterator$1Class;
function engines$iterator$1() {
  if (engines$iterator$1Class === VOID) {
    class $ {
      constructor() {
        this.d61_1 = engines_getInstance().i60_1.kotlinx$atomicfu$value;
      }
      r1() {
        var result = ensureNotNull(this.d61_1);
        this.d61_1 = result.c61_1;
        return result.b61_1;
      }
      q1() {
        return !(null == this.d61_1);
      }
    }
    initMetadataForClass($);
    engines$iterator$1Class = $;
  }
  return engines$iterator$1Class;
}
var enginesClass;
function engines() {
  if (enginesClass === VOID) {
    class $ {
      constructor() {
        engines_instance = this;
        this.i60_1 = atomic$ref$1(null);
      }
      j60(item) {
        $l$loop: while (true) {
          var current = this.i60_1.kotlinx$atomicfu$value;
          var new_0 = new (Node())(item, current);
          if (this.i60_1.atomicfu$compareAndSet(current, new_0))
            break $l$loop;
        }
      }
      p1() {
        return new (engines$iterator$1())();
      }
    }
    initMetadataForObject($, 'engines');
    enginesClass = $;
  }
  return enginesClass;
}
var engines_instance;
function engines_getInstance() {
  if (engines_instance === VOID)
    new (engines())();
  return engines_instance;
}
//region block: exports
export {
  engines_getInstance as engines_getInstanceb5dt08q6u0mu,
};
//endregion

//# sourceMappingURL=Loader.mjs.map
